import {useSelector} from 'Provider';

import {Property} from 'store/properties/properties.interface';
import {propertiesDataSelector} from 'store/properties/properties.selectors';

/**
 * This hook helps map a propertyList from an Offer to the full properties
 * objects returned by by the API. It will only return the properties which
 * have a matching Property object.
 * @param propertyList The property names from an offer.
 * @returns The full list of properties for the given property names.
 */
export const usePropertyList = (propertyList: string[] = []) => {
  try {
    const properties = useSelector(propertiesDataSelector);
    const notFound: string[] = [];

    const offerProperties = propertyList.reduce<Property[]>(
      (mappedPropertyList, propertyId) => {
        const property = properties.find(
          currentProperty => currentProperty.id === propertyId.toLowerCase()
        );
        if (property && property.propertyName) {
          return [...mappedPropertyList, property];
        }
        notFound.push(propertyId);
        return mappedPropertyList;
      },
      []
    );
    return {offerProperties, notFound};
  } catch (e) {
    return {
      offerProperties: [],
      notFound: [],
      error: 'Failed to map property codes to properties',
    };
  }
};
